import { ConfirmationModal } from "@/components/ui/ConfirmationModal/ConfirmationModal";
import type { EmptyQuestion } from "./findEmptyQuestions";
import styles from "./EmptyQuestionsModal.module.scss";

interface EmptyQuestionsModalProps {
  issues: EmptyQuestion[];
  onClose: () => void;
  onGoToField: (issue: EmptyQuestion) => void;
}

const fieldCountLabel = (count: number) =>
  `${count} ${count === 1 ? "field has" : "fields have"} no question`;

export function EmptyQuestionsModal({ issues, onClose, onGoToField }: EmptyQuestionsModalProps) {
  return (
    <ConfirmationModal
      isOpen={issues.length > 0}
      onClose={onClose}
      title={fieldCountLabel(issues.length)}
      size="md"
      cancelText="Close"
      confirmText="Go to field"
      onConfirm={() => issues[0] && onGoToField(issues[0])}
      body={
        <div className={styles.body}>
          <p className={styles.intro}>
            Service providers would see these as &ldquo;Untitled&rdquo;. Add a question to each
            before publishing.
          </p>
          <ul className={styles.list}>
            {issues.map((issue, index) => (
              <li key={`${issue.questionId}-${index}`}>
                {issue.pageName} · {issue.sectionName} · {issue.typeName}
              </li>
            ))}
          </ul>
        </div>
      }
    />
  );
}
